import { PATTERNS } from '@components/utils/constants'
import { IRequestQuoteData } from '@hooks/useRequestQuote'
import { useEffect } from 'react'
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form'
import 'react-phone-number-input/style.css'
import InputPhone from '@libs/forms/InputPhone'

const MAX_LENGTH = 64
const MAX_LENGTH_EMAIL = 320
const regexNameFilter = /[^a-zA-Z .,‘’'-]/gi
const regexPhoneFilter = /[^a-zA-Z0-9 .:;,"“”'‘’()!?+/-]/gi
const regexEmailFilter = /[^a-zA-Z0-9 !#$%&'*+-/=?^_`{|}~.@]/gi

interface IInputForms {
  onClick: (isOpen: boolean, isSuccessMobile?: boolean | undefined) => void
  onRequestSubmit: (data: IRequestQuoteData) => Promise<void>
}

const InputForms = ({ onClick, onRequestSubmit }: IInputForms): JSX.Element => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm()

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      //  CODE SNIPPET BELOW is custom js length validation as default one is not working on android devices
      if (type === 'change') {
        let allowedLength = MAX_LENGTH
        if (name === 'email') {
          allowedLength = MAX_LENGTH_EMAIL
        }
        // @ts-expect-error
        if (value[name].length > allowedLength) {
          // @ts-expect-error
          value[name] = value[name].slice(0, allowedLength)
          // @ts-expect-error
          setValue(name, value[name])
        }

        // Below is not else case because if pasted it has to be validated as well

        if (name === 'fullName') {
          // The other apostrophies are the ones support by iPhone Devices
          const cleanedValue = value.fullName.replaceAll(regexNameFilter, '')
          setValue('fullName', cleanedValue)
        } else if (name === 'email') {
          const cleanedValue = value.email.replaceAll(regexEmailFilter, '')
          setValue('email', cleanedValue)
        } else if (name === 'phoneNumber') {
          const cleanedValue = value.phoneNumber.replaceAll(
            regexPhoneFilter,
            '',
          )
          setValue('phoneNumber', cleanedValue)
        }
      }
    })

    return () => subscription.unsubscribe()
  }, [watch])

  useEffect(() => {
    // @ts-expect-error
    const fullName = document?.getElementById('fullName')?.value.length
    // @ts-expect-error
    const email = document?.getElementById('email')?.value.length
    // @ts-expect-error
    const phoneNumber = document?.getElementById('phoneNumber')?.value.length
    if (
      Object.keys(errors).length === 0 &&
      fullName &&
      email &&
      phoneNumber > 0
    ) {
      document
        ?.getElementById('submit-btn')
        ?.addEventListener('click', () => onClick(true, false))
    }
  }, [errors.fullName, errors.email, errors.phoneNumber])

  return (
    <form
      noValidate
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSubmit={handleSubmit(onRequestSubmit as SubmitHandler<FieldValues>)}
    >
      <div className='input-label'>Full Name*</div>
      <input
        type='text'
        id='fullName'
        placeholder='Enter name'
        className={`input-field ${errors.fullName ? 'error-field' : ''}`}
        maxLength={MAX_LENGTH}
        {...register('fullName', {
          required: {
            value: true,
            message: 'Full Name field is required',
          },
        })}
      />
      {typeof errors.fullName?.message === 'string' && (
        <span className='error-text'>{errors.fullName.message}</span>
      )}
      <div className='input-label'>Email Address*</div>
      <input
        type='email'
        id='email'
        placeholder='Enter email'
        className={`input-field ${errors.fullName ? 'error-field' : ''}`}
        maxLength={MAX_LENGTH_EMAIL}
        {...register('email', {
          required: { value: true, message: 'Email field is required' },
          pattern: {
            value: PATTERNS.EMAIL_VALIDATION_PATTERN,
            message: 'Please enter valid email address',
          },
        })}
      />

      {typeof errors.email?.message == 'string' && (
        <span className='error-text'>{errors.email.message}</span>
      )}
      <div className='input-label'>Phone</div>

      <InputPhone name='phoneNumber' />

      <button
        id='submit-btn'
        type='submit'
        className='mt-8 flex w-[100%] justify-center rounded-full bg-orange p-[1.375rem] font-semibold text-white desktop:w-[424px]'
      >
        Request a Custom Quote
      </button>
    </form>
  )
}

export default InputForms
